export default {
  getAllUsers: state => state.users,
  getSpecificUser: state => state.user,
  getAllRoles: state => state.roles,
  getAllQueues: state => state.queues,
  getAllAgents: state => state.agents,
  getAllRamais: state => state.ramais,
  getAllTags: state => state.tags,
  getAllConferencias: state => state.conferencias,
  getAllPesquisas: state => state.pesquisas,
}
